const convertDateToLocaleString = (type: 'date' | 'dateTime', date: string, locale: string) => {
  if (type === 'date') {
    return new Date(date).toLocaleDateString(locale);
  }

  const utc = new Date(date);
  const offset = utc.getTimezoneOffset();
  const dateTime = new Date(utc.getTime() - offset * 60000).toLocaleString(locale);

  return dateTime;
};

export default convertDateToLocaleString;
